module.exports = __webpack_public_path__ + "img/art_2_3.e156eb52.jpeg";